import Settings from './Settings.vue';
import MenuItem from './MenuItem.vue';

const routes = [
  {
    name: 'modules.business',
    component: Settings,
    path: '/modules/business',
  },
];

export default {
  menu_item: MenuItem,
  settings_component: Settings,
  routes,
};
